// extracted by mini-css-extract-plugin
export default {"backLink":"ForgotPassword_backLink__H7Us1","backArrow":"ForgotPassword_backArrow__MvSoJ","description":"ForgotPassword_description__lRbUu"};